"use strict";

exports.__esModule = true;
exports.EditTypesSection = EditTypesSection;
var _react = _interopRequireDefault(require("react"));
var _FormGroupField = require("../../Form/FormGroupField");
var _DetailsComponent = require("../../Core/DetailsComponent");
var _Translator = require("../../Core/Translator");
var _TicketTypeSelector = require("../../Logbook/TicketTypeSelector");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function EditTypesSection(props) {
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var ticketTypes = props.ticketTypes,
    filteredTicketTypes = props.filteredTicketTypes,
    style = props.style;
  var nonDeviceTicketTypes = ticketTypes.filter(function (tt) {
    return !filteredTicketTypes.includes(tt);
  });
  var ticketTypesGrouped = [].concat(filteredTicketTypes, nonDeviceTicketTypes);
  function validateTypes(value) {
    if (!Array.isArray(value) || value.length === 0) {
      return translate("TicketDetailsEditForm.typeError", "Type is required.");
    }
  }
  return /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSubSection, {
    heading: translate("TicketDetailsEditForm.types", "Types"),
    content: /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
      name: "type",
      validate: validateTypes,
      style: style
    }, function (_ref) {
      var input = _ref.input;
      return /*#__PURE__*/_react["default"].createElement(_TicketTypeSelector.TicketTypeSelector, {
        minimal: true,
        getItemCategory: function getItemCategory(item) {
          return nonDeviceTicketTypes.includes(item) ? "Device" : "Other";
        },
        getCategoryTitle: function getCategoryTitle(input) {
          return input;
        },
        items: ticketTypesGrouped,
        selected: input.value || [],
        onSelect: input.onChange
      });
    })
  });
}